import store from '../store'

export default function auth({ next, router }) {
    if (store.getters["auth/getUser"] == null) {
      return router.push("/login");
    }
  
    return next();
  }